import { SchrittSuccessPayload, VorgangProzessSchritt } from '@core/domain';
import { ShieldCheck } from 'lucide-react';
import { TimelineElement } from '@/components/ui/timeline/timeline-types';
import {
  VorgangDetailSchritt,
  STATUS_PROPERTY_MAP,
} from '@/features/vorgangHistorie/utils/common';

const getAussteuerungsInformationSentence = ({
  verworfen,
  ausgesteuert,
}: {
  verworfen: boolean;
  ausgesteuert: boolean;
}): string | null => {
  if (verworfen && ausgesteuert) {
    return 'Der OPM-Vorgang ist verworfen und ausgesteuert.';
  } else if (verworfen) {
    return 'Der OPM-Vorgang ist verworfen.';
  } else if (ausgesteuert) {
    return 'Der OPM-Vorgang ist ausgesteuert.';
  }
  return null;
};

const getFachlicheValidierungDetails = (
  successPayload: SchrittSuccessPayload<VorgangProzessSchritt.FACHLICHE_VALIDIERUNG>,
) => {
  if (!successPayload) {
    return 'Es ist keine Aussteuerung vorhanden.';
  }

  const { verworfen, ausgesteuert, unterdrueckungsNachrichten } =
    successPayload.aussteuerungsInformation;

  const aussteuerungsInformationSentence = getAussteuerungsInformationSentence({
    verworfen,
    ausgesteuert,
  });

  if (
    aussteuerungsInformationSentence === null &&
    Number(unterdrueckungsNachrichten?.length) === 0
  ) {
    return 'Es wurde keine Aussteuerung durchgeführt.';
  }
  return (
    <>
      {aussteuerungsInformationSentence !== null && (
        <p className={'mt-2'}>{aussteuerungsInformationSentence}</p>
      )}
      {Number(unterdrueckungsNachrichten?.length) > 0 && (
        <ul className={'list-decimal mt-2'}>
          {unterdrueckungsNachrichten.map((detail, idx) => (
            <li key={idx}>{detail}</li>
          ))}
        </ul>
      )}
    </>
  );
};

export const getTimelineItemForAussteuerung = (
  schritt: VorgangDetailSchritt,
): Omit<TimelineElement, 'id'> | null => {
  return {
    date: new Date(schritt.startedAt ?? schritt.createdAt),
    description: getFachlicheValidierungDetails(
      schritt.successPayload as SchrittSuccessPayload<VorgangProzessSchritt.FACHLICHE_VALIDIERUNG>,
    ),
    initiator: 'system',
    title: 'Prüfung Unterdrückungsbedingungen',
    icon: <ShieldCheck />,
    ...STATUS_PROPERTY_MAP[schritt.status],
  };
};
